<script setup>
import { computed } from 'vue';
import { useI18n } from 'vue-i18n';
import ExpandableText from 'components/ui/ExpandableText.vue';

const props = defineProps({
  payload: {
    type: Object,
    default: () => ({}),
  },
});

const { t } = useI18n();

const content = computed(() => props.payload.content || '');
</script>

<template>
  <div class="flex flex-col gap-3">
    <h4 class="text-xs font-semibold uppercase tracking-wide text-n-slate-11">
      {{ t('BROADCASTS.MESSAGE') }}
    </h4>

    <div
      class="bg-n-alpha-2 border border-n-strong rounded-lg overflow-hidden flex flex-col p-3"
    >
      <ExpandableText
        :content="content || t('BROADCASTS.NO_MESSAGE')"
        :expand-text="t('BROADCASTS.MESSAGE_SHOW')"
        :collapse-text="t('BROADCASTS.MESSAGE_HIDE')"
      />
    </div>

    <div class="text-xs text-n-slate-11">
      {{ t('BROADCASTS.MESSAGE_TYPE') }}
      <span class="text-n-slate-12 font-medium">
        {{ payload.content_type || '—' }}
      </span>
    </div>
  </div>
</template>
